export const operationsWithOs = {
  getOS() {
    if (typeof navigator === 'undefined') return 'android';

    const ua = navigator.userAgent;
    const platform = navigator.platform;

    console.log("UA", ua)
    console.log("platform", platform)


    const isApple =
      /iPhone|iPad|iPod|Macintosh|MacIntel/.test(ua) ||
      /Mac/.test(platform);

    const isSafari =
      /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(ua);

    return isApple || isSafari ? 'iOS' : 'android';
  }
};